import { memo } from 'react';

import { LayersIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { AssetModalPanel, useAssetModalPanelContext } from '~/providers/AssetModalPanelContextProvider';

export const MobileVersionsTab = memo(() => {
  const { showPanel } = useAssetModalPanelContext();

  return (
    <IconButton
      adsIcon
      appearance="ghost"
      color="gray"
      data-testid="VERSIONS_PANEL"
      icon={LayersIcon}
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={() => showPanel(AssetModalPanel.VERSIONS)}
      size="large"
      label="Versions panel"
    />
  );
});

MobileVersionsTab.displayName = 'MobileVersionsTab';
